var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info != null)?_c('file-preview',{attrs:{"info":_vm.info,"draggable":_vm.draggable},on:{"remove":function($event){return _vm.$emit('remove', _vm.mediaId)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }